import merge from "lodash/merge";
import accordion from "./accordion";
import alert from "./alert";
import appBar from "./appBar";
import autocomplete from "./autocomplete";
import avatar from "./avatar";
import backdrop from "./backdrop";
import badge from "./badge";
import bottomNavigation from "./bottomNavigation";
import breadcrumbs from "./breadcrumbs";
import button from "./button";
import card from "./card";
import checkbox from "./checkbox";
import chip from "./chip";
import circularProgress from "./circularProgress";
import cssBaseline from "./cssBaseline";
import dialog from "./dialog";
import divider from "./divider";
import drawer from "./drawer";
import fab from "./fab";
import formControl from "./formControl";
import formControlLabel from "./formControlLabel";
import formGroup from "./formGroup";
import formHelperText from "./formHelperText";
import formLabel from "./formLabel";
import iconButton from "./iconButton";
import imageList from "./imageList";
import input from "./input";
import linearProgress from "./linearProgress";
import link from "./link";
import list from "./list";
import menu from "./menu";
import menuItem from "./menuItem";
import mobileStepper from "./mobileStepper";
import pagination from "./pagination";
import paper from "./paper";
import popover from "./popover";
import radio from "./radio";
import rating from "./rating";
import select from "./select";
import skeleton from "./skeleton";
import slider from "./slider";
import snackbar from "./snackbar";
import speedDial from "./speedDial";
import stepper from "./stepper";
import switchOverrides from "./switch";
import table from "./table";
import tablePagination from "./tablePagination";
import tabs from "./tabs";
import textField from "./textField";
import toggleButton from "./toggleButton";
import toolbar from "./toolbar";
import tooltip from "./tooltip";
export default function ComponentsOverrides(themeOptions) {
    return merge(accordion(themeOptions), alert(themeOptions), appBar(themeOptions), autocomplete(themeOptions), avatar(themeOptions), backdrop(themeOptions), badge(themeOptions), bottomNavigation(themeOptions), breadcrumbs(themeOptions), button(themeOptions), card(themeOptions), checkbox(themeOptions), chip(themeOptions), circularProgress(themeOptions), cssBaseline(themeOptions), dialog(themeOptions), divider(themeOptions), drawer(themeOptions), fab(themeOptions), formControl(themeOptions), formControlLabel(themeOptions), formGroup(themeOptions), formHelperText(themeOptions), formLabel(themeOptions), iconButton(themeOptions), imageList(themeOptions), input(themeOptions), linearProgress(themeOptions), link(themeOptions), list(themeOptions), menu(themeOptions), menuItem(themeOptions), mobileStepper(themeOptions), pagination(themeOptions), paper(themeOptions), popover(themeOptions), radio(themeOptions), rating(themeOptions), select(themeOptions), skeleton(themeOptions), slider(themeOptions), snackbar(themeOptions), speedDial(themeOptions), stepper(themeOptions), switchOverrides(themeOptions), table(themeOptions), tablePagination(themeOptions), tabs(themeOptions), textField(themeOptions), toggleButton(themeOptions), toolbar(themeOptions), tooltip(themeOptions));
}
//# sourceMappingURL=index.js.map